export class AudioFileDetailModel {
	public id: string; // id of widget
	public widgetProperty: string; // widget property name
	public audioFile: string;
	public fileName: string;
	public language: string;

	constructor() {
		this.id = "";
		this.widgetProperty = "";
		this.audioFile = "";
		this.fileName = "";
		this.language = "";
	}
}

export default class UploadAudioFileRequestModel {
	public partitionKey: string;
	public rowKey: string;
	public containerName: string;
	public files: AudioFileDetailModel[];

	constructor() {
		this.partitionKey = "";
		this.rowKey = "";
		this.containerName = "";
		this.files = [];
	}
}
